const host = (env) => {
  const hostList = [
    {
      env: 'local',
      // nodeUrl: 'http://localhost:5003',
      // mdoUrl: 'http://localhost:5001',
      nodeUrl: 'https://nodetest.sgsonline.com.cn',
      mdoUrl: 'https://mallmdotest.sgsonline.com.cn',
      sgsonlineUrl: 'http://cmsuat.sgsonline.com.cn',
      portalUrl: 'http://portaluat.sgsonline.com.cn',
      storeUrl: 'http://ticuat.sgsonline.com.cn',
      mallUrl: 'https://uat.sgsmall.com.cn',
      javaUrl: 'https://gateuat.sgsonline.com.cn',
      domain: 'http://localhost',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'http://localhost:9505',
    },
    {
      env: 'dev',
      nodeUrl: 'https://nodedev.sgsonline.com.cn',
      mdoUrl: 'https://mallmdodev.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmsdev.sgsonline.com.cn',
      portalUrl: 'http://portaldev.sgsonline.com.cn',
      storeUrl: 'https://ticdev.sgsonline.com.cn',
      mallUrl: 'https://dev.sgsmall.com.cn',
      javaUrl: 'https://gatedev.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://memberdev.sgsonline.com.cn',
    },
    {
      env: 'uat',
      nodeUrl: 'https://nodeuat.sgsonline.com.cn',
      mdoUrl: 'https://mallmdouat.sgsonline.com.cn',
      sgsonlineUrl: 'http://cmsuat.sgsonline.com.cn',
      portalUrl: 'http://portaluat.sgsonline.com.cn',
      storeUrl: 'http://ticuat.sgsonline.com.cn',
      mallUrl: 'https://uat.sgsmall.com.cn',
      javaUrl: 'https://gateuat.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://memberuat.sgsonline.com.cn',
    },
    {
      env: 'test',
      nodeUrl: 'https://nodetest.sgsonline.com.cn',
      mdoUrl: 'https://mallmdotest.sgsonline.com.cn',
      sgsonlineUrl: 'http://cmstest.sgsonline.com.cn',
      portalUrl: 'http://portaltest.sgsonline.com.cn',
      storeUrl: 'http://tictest.sgsonline.com.cn',
      mallUrl: 'https://test.sgsmall.com.cn',
      javaUrl: 'https://gatetest.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://membertest.sgsonline.com.cn',
    },
    {
      env: 'prod',
      nodeUrl: 'https://node.sgsonline.com.cn',
      mdoUrl: 'https://mallmdo.sgsonline.com.cn',
      sgsonlineUrl: 'https://www.sgsonline.com.cn',
      portalUrl: 'http://portal.sgsonline.com.cn',
      storeUrl: 'https://store.sgsonline.com.cn',
      mallUrl: 'https://www.sgsmall.com.cn',
      javaUrl: 'https://gate.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://member.sgsonline.com.cn',
    },
    {
      env: 'uatGray',
      nodeUrl: 'https://nodeuatgray.sgsonline.com.cn',
      mdoUrl: 'https://mallmdouatgray.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmsuatgray.sgsonline.com.cn',
      portalUrl: 'http://portaluatgray.sgsonline.com.cn',
      storeUrl: 'https://ticuatgray.sgsonline.com.cn',
      mallUrl: 'https://uatgray.sgsmall.com.cn',
      javaUrl: 'https://gateuat.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      version: 'gray',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://memberuatgray.sgsonline.com.cn',
    },
    {
      env: 'prodGray',
      nodeUrl: 'https://nodegray.sgsonline.com.cn',
      mdoUrl: 'https://mallmdogray.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmsgray.sgsonline.com.cn',
      portalUrl: 'http://portalgray.sgsonline.com.cn',
      storeUrl: 'https://store.sgsonline.com.cn',
      mallUrl: 'https://gray.sgsmall.com.cn',
      javaUrl: 'https://gate.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      version: 'gray',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://membergray.sgsonline.com.cn',
    },
  ]
  return hostList.find(v => v.env === env)
}

export {
  host
}